// @react/hooks/usePayment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { paymentStore } from '@core/stores';

/**
 * React hook for Payment operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { usePayment } from '@react/hooks';
 *
 * const PaymentList = observer(() => {
 *   const store = usePayment();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function usePayment() {
  return paymentStore;
}
